import React from "react";
import { NavLink } from "react-router-dom";
import * as FiIcons from "react-icons/fi";

export default function BottomMenu() {
  let activeStyle = {
    color: "#00fff5",
  };
  let activeClassName = "#00fff5";
  return (
    <div className="md:hidden">
      <div className="bottom-menu">
        <ul>
          <li className="item">
            <NavLink
              to="/"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <FiIcons.FiHome color="#00fff5" size={"2rem"} />
            </NavLink>
            <small className="text-sm text-[#00fff5]">Home</small>
          </li>
          <li className="item">
            <NavLink
              to="/about"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <FiIcons.FiUser size={"2rem"} />
              <small>About</small>
            </NavLink>
          </li>
          <li className="item">
            <NavLink
              to="/portfolio"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <FiIcons.FiGrid size={"2rem"} />
              <small>Portfolio</small>
            </NavLink>
          </li>
          <li className="item">
            <NavLink
              to="/contact"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <FiIcons.FiHelpCircle size={"2rem"} />
              <small>Contact</small>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
